import React, { Component } from 'react';
import api from '../services/api.js';
import apiString from '../services/apiString.js';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import InputMask from 'react-input-mask';

import theme from './themes/Theme';
import { ThemeProvider } from '@mui/material/styles';
import { withRouter } from '../withRouter.js';

import backgroundImage from '../assets/kprocessos_background.png';
import logo from '../assets/kprocessos_fav_logo.png';

import Footer from '../components/Footer.js';

class Login extends Component {

  state = {
    option: 'cnpj',
    type: 'E-mail',
    mask: '',
    login: '',
    email: '',
    password: '',
    city: 'tresrios',
    secretary: 'mendes',
    emailView: true,

    open_error: false,
    msg: '',
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (this.state.option === 'cnpj' || this.state.option === 'admin') {
      await this.setState({ login: this.state.email });
    }

    const data = new FormData();

    data.append('login', this.state.login);

    /*if ( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.props.history.push('/report');*/
    //} else {

    try {
      let resp = await api.get('/checkuser', {
        params: {
          cpf_cnpj: this.state.login,
          city: this.state.city,
          password: this.state.password,
        }
      });
      //alert(this.state.city);
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('name')) {
            if (this.state.option === 'cpf') {
              const stateData = {
                pathname: '/citzenhome',
                state: {
                  fields: {
                    user_id: JSON.stringify(resp.data[0].id),
                    login: data.get('login'),
                    option: this.state.option,
                    selected_city: this.state.city
                  }
                }
              };
              console.log('[Login] Navegando para CitzenHome com state:', stateData);
              this.props.history.push(stateData);
            } else if ((this.state.option === 'cnpj') && (this.state.city === 'rio')) {
              const stateData = {
                pathname: '/homerio',
                state: {
                  fields: {
                    login: data.get('login'),
                    option: this.state.option,
                    selected_city: this.state.city
                  }
                }
              };
              console.log('[Login] Navegando para HomeRio com state:', stateData);
              this.props.history.push(stateData);
            } else {
              if ((this.state.option === 'cnpj') && (this.state.city === 'mendes')) {
                this.props.history.push({
                  pathname: '/home',
                  state: {
                    fields: {
                      login: data.get('login'),
                      option: this.state.option,
                      selected_city: this.state.city
                    }
                  }
                });
              } else {
                if ((this.state.option === 'cnpj') && (this.state.city === 'paulo')) {
                  this.props.history.push({
                    pathname: '/homepaulo',
                    state: {
                      fields: {
                        user_id: JSON.stringify(resp.data[0].id),
                        login: data.get('login'),
                        option: this.state.option,
                        selected_city: this.state.city,
                        name: JSON.stringify(resp.data[0].name),
                        secretary: JSON.stringify(resp.data[0].secretary),
                        secretary_id: JSON.stringify(resp.data[0].secretary_id)
                      }
                    }
                  });
                } else {
                  if ((this.state.option === 'cnpj') && ((this.state.city === 'tresrios') || (this.state.city === 'rios'))) {
                    this.props.history.push({
                      pathname: '/hometresrios',
                      state: {
                        fields: {
                          user_id: JSON.stringify(resp.data[0].id),
                          login: data.get('login'),
                          option: this.state.option,
                          selected_city: this.state.city,
                          name: JSON.stringify(resp.data[0].name),
                          secretary: JSON.stringify(resp.data[0].secretary),
                          secretary_id: JSON.stringify(resp.data[0].secretary_id)
                        }
                      }
                    });
                  } else {
                    if ((this.state.option === 'cnpj') && (this.state.city === 'cabo')) {
                      this.props.history.push({
                        pathname: '/homecabo',
                        state: {
                          fields: {
                            user_id: JSON.stringify(resp.data[0].id),
                            login: data.get('login'),
                            option: this.state.option,
                            selected_city: this.state.city,
                            name: JSON.stringify(resp.data[0].name),
                            secretary: JSON.stringify(resp.data[0].secretary),
                            secretary_id: JSON.stringify(resp.data[0].secretary_id)
                          }
                        }
                      });
                    } else {
                      if ((this.state.option === 'cnpj') && (this.state.city === 'nova')) {
                        this.props.history.push({
                          pathname: '/homenova',
                          state: {
                            fields: {
                              user_id: JSON.stringify(resp.data[0].id),
                              login: data.get('login'),
                              option: this.state.option,
                              selected_city: this.state.city,
                              name: JSON.stringify(resp.data[0].name),
                              secretary: JSON.stringify(resp.data[0].secretary),
                              secretary_id: JSON.stringify(resp.data[0].secretary_id)
                            }
                          }
                        });
                      } else {
                        if ((this.state.option === 'cnpj') && (this.state.city === 'saquarema')) {
                          this.props.history.push({
                            pathname: '/homesaquarema',
                            state: {
                              fields: {
                                user_id: JSON.stringify(resp.data[0].id),
                                login: data.get('login'),
                                option: this.state.option,
                                selected_city: this.state.city,
                                name: JSON.stringify(resp.data[0].name),
                                secretary: JSON.stringify(resp.data[0].secretary),
                                secretary_id: JSON.stringify(resp.data[0].secretary_id)
                              }
                            }
                          });
                        } else {
                          if ((this.state.option === 'cnpj') && (this.state.city === 'queimados')) {
                            this.props.history.push({
                              pathname: '/homequeimados',
                              state: {
                                fields: {
                                  user_id: JSON.stringify(resp.data[0].id),
                                  login: data.get('login'),
                                  option: this.state.option,
                                  selected_city: this.state.city,
                                  name: JSON.stringify(resp.data[0].name),
                                  secretary: JSON.stringify(resp.data[0].secretary),
                                  secretary_id: JSON.stringify(resp.data[0].secretary_id)
                                }
                              }
                            });
                          } else {
                            if ((this.state.option === 'cnpj') && (this.state.city === 'itaocara')) {
                              this.props.history.push({
                                pathname: '/homeitaocara',
                                state: {
                                  fields: {
                                    user_id: JSON.stringify(resp.data[0].id),
                                    login: data.get('login'),
                                    option: this.state.option,
                                    selected_city: this.state.city,
                                    name: JSON.stringify(resp.data[0].name),
                                    secretary: JSON.stringify(resp.data[0].secretary),
                                    secretary_id: JSON.stringify(resp.data[0].secretary_id)
                                  }
                                }
                              });
                            } else {
                              if ((this.state.option === 'cnpj') && (this.state.city === 'campos')) {
                                this.props.history.push({
                                  pathname: '/homecampos',
                                  state: {
                                    fields: {
                                      user_id: JSON.stringify(resp.data[0].id),
                                      login: data.get('login'),
                                      option: this.state.option,
                                      selected_city: this.state.city,
                                      name: JSON.stringify(resp.data[0].name),
                                      secretary: JSON.stringify(resp.data[0].secretary),
                                      secretary_id: JSON.stringify(resp.data[0].secretary_id)
                                    }
                                  }
                                });
                              } else {
                                if ((this.state.option === 'cnpj') && (this.state.city === 'rj')) {
                                  this.props.history.push({
                                    pathname: '/homerj',
                                    state: {
                                      fields: {
                                        user_id: JSON.stringify(resp.data[0].id),
                                        login: data.get('login'),
                                        option: this.state.option,
                                        selected_city: this.state.city,
                                        name: JSON.stringify(resp.data[0].name),
                                        secretary: JSON.stringify(resp.data[0].secretary),
                                        secretary_id: JSON.stringify(resp.data[0].secretary_id)
                                      }
                                    }
                                  });
                                } else {
                                  if ((this.state.option === 'admin')) {
                                    this.props.history.push({
                                      pathname: '/homeadmin',
                                      state: {
                                        fields: {
                                          user_id: JSON.stringify(resp.data[0].id),
                                          login: data.get('login'),
                                          option: this.state.option,
                                          selected_city: this.state.city,
                                          name: JSON.stringify(resp.data[0].name),
                                          secretary: JSON.stringify(resp.data[0].secretary),
                                          secretary_id: JSON.stringify(resp.data[0].secretary_id)
                                        }
                                      }
                                    });
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

          } else {
            let msg = JSON.stringify(resp.data);
            const finalmsg = msg.toString().split('"').join('');
            this.setState({ msg: finalmsg });
            this.setState({ open_error: true });
          }
        }
      }
    } catch (err) {
      console.error(err);
      this.setState({ msg: 'CNPJ/CPF incorreto. ' + err });
      this.setState({ open_error: true });
    }

    //}

  }

  handleMask = async e => {
    await this.setState({ [e.target.name]: e.target.value });

    if (this.state.option == "cnpj") {
      this.setState({ emailView: true });
      this.setState({ mask: '' });
      this.setState({ type: 'E-mail' });
    }
    if (this.state.option == "cpf") {
      this.setState({ emailView: false });
      this.setState({ mask: '999.999.999-99' });
      this.setState({ type: 'CPF' });
    }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <html style={styles.html}>
        <div style={styles.overlay}></div>
        <ThemeProvider theme={theme}>
          <div style={styles.divForm}>
            <form style={styles.form} id="new_login" onSubmit={this.handleSubmit}>

              <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div style={styles.paper}>
                  <img src={logo} style={styles.avatar} />
                  <Typography component="h1" variant="h5">
                    Login
                  </Typography>

                  {this.state.open_error ? (
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            this.setState({ open_error: false });
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {this.state.msg}
                    </Alert>
                  ) : null}

                  <div style={styles.form}>

                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">Opção</FormLabel>
                        <RadioGroup
                          aria-label="option1"
                          name="option"
                          value={this.state.option}
                          onChange={this.handleMask}
                          style={{ display: 'flex', flexDirection: 'row', width: '102%' }}
                        >
                          <FormControlLabel value="admin" control={<Radio />} label="Administrador" />
                          <FormControlLabel value="cnpj" control={<Radio />} label="Analista" />
                          <FormControlLabel value="cpf" control={<Radio />} label="Requerente" />
                        </RadioGroup>
                      </FormControl>

                      <FormControl variant="outlined" style={{ width: 350 }}>
                        <InputLabel htmlFor="outlined-city-native-simple">
                          Município *
                        </InputLabel>
                        <Select
                          native
                          required
                          value={this.state.city}
                          onChange={this.handleChange}
                          label="Município"
                          inputProps={{
                            name: 'city',
                            id: 'outlined-city-native-simple',
                          }}
                        >
                          <option value="cabo">Cabo Frio</option>
                          <option value="campos">Campos</option>
                          <option value="itaocara">Itaocara</option>
                          <option value="nova">Nova Iguaçu</option>
                          <option value="queimados">Queimados</option>
                          <option value="rj">Rio de Janeiro</option>
                          <option value="rios">Três Rios</option>
                          <option value="paulo">Paulo de Frontin</option>
                          <option value="saquarema">Saquarema</option>
                          {/*<option value="direitos_humanos">Direitos Humanos</option>
                        <option value="meio_ambiente">Meio Ambiente</option>
                        <option value="saude">Saúde</option>*/}
                        </Select>
                      </FormControl>
                    </div>

                    {this.state.emailView ? (
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="E-mail"
                        name="email"
                        autoComplete="email"
                        //InputProps={{ style: styles.input }}
                        onChange={this.handleChange}
                        value={this.state.email}
                      />
                    ) : (
                      <InputMask
                        {...this.props.value}
                        mask={this.state.mask}
                        fullWidth
                        maskChar=" "
                        required
                        name="login"
                        id="login"
                        type="text"
                        onChange={this.handleChange}
                        value={this.state.login}
                      >
                        {(inputProps) =>
                          <TextField
                            {...inputProps}
                            variant="outlined"
                            margin="normal"
                            label={this.state.type}
                          />
                        }
                      </InputMask>
                    )}

                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      name="password"
                      label="Senha"
                      type="password"
                      id="password"
                      autoComplete="current-password"
                      InputProps={{ style: styles.input }}
                      onChange={this.handleChange}
                      value={this.state.password}
                    />
                    <FormControlLabel
                      control={<Checkbox value="remember" color="primary" />}
                      label="Lembrar de mim"
                    />
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      style={styles.submit}
                      startIcon={<ExitToAppIcon />}
                    >
                      Entrar
                    </Button>
                    <Grid container>
                      <Grid item xs>
                        <Link href="#" variant="body2" style={styles.link}>
                          Esqueceu a senha?
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link href={`${apiString}/register`} variant="body2" style={styles.link}>
                          {"Criar nova conta"}
                        </Link>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Container>
              <Footer />
            </form>
          </div>
        </ThemeProvider>
      </html>
    );
  }
}

let styles = {
  html: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 0,
  },
  paper: {
    padding: 30,
    marginTop: -20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#E5E6F0',
    position: 'relative',
  },
  avatar: {
    alignSelf: 'center',
    width: 100,
    height: 100,
    marginBottom: 10,
    marginTop: -10,
    marginRight: 30,
  },
  divForm: {
    alignSelf: 'center',
    position: 'relative',
    zIndex: 1,
  },
  form: {
    width: '99%', // Fix IE 11 issue.
    paddingTop: 50,
  },
  /*input: {
    color: '#fff',
  },*/
  submit: {
    marginTop: 10,
    marginBottom: 10,
    textTransform: 'none',
    backgroundColor: '#d9be29',
  },
  link: {
    color: '#323232',
  },
};

export default withRouter(Login);